export const GET_SEO_QUICK_FIX_SCORE = "SEOV2/GET_SEO_QUICK_FIX_SCORE";
export const GET_SEO_DETAIL_BY_TYPE = "SEOV2/GET_SEO_DETAIL_BY_TYPE";
export const UPDATE_SEO_DETAIL_BY_TYPE = "SEOV2/UPDATE_SEO_DETAIL_BY_TYPE";
export const GET_SEO_REPORT = "SEOV2/GET_SEO_REPORT";
export const GET_GSC_DETAILS = "SEOV2/GET_GSC_DETAILS";
